import { IAddTaskPayload } from './tasks.interface';

export class AddTask {
  static readonly type = '[Tasks] Add Task';
  constructor(public payload: IAddTaskPayload) {}
}

export class StartTask {
  static readonly type = '[Tasks] start Task';
}

export class CompleteTask {
  static readonly type = '[Tasks] complete Task';
  constructor(public payload: IAddTaskPayload) {}
}

export class RemoveTask {
  static readonly type = '[Tasks] remove Task';
  constructor(public taskName: string) {}
}

export class ErrorTask {
  static readonly type = '[Tasks] error Task';
  constructor(public payload: IAddTaskPayload) {}
}

export class Retry {
  static readonly type = '[Tasks] Retry';
  constructor(public payload: string) {}
}

export class ClearTasks {
  static readonly type = '[Tasks] Clear Tasks';
}
